import { ManagerOfCompany, Pagination } from '@interfaces';
import { Action, createReducer, on } from '@ngrx/store';
import * as companyActions from './company.actions';
import { CompanyState, defaultPagination, initialState } from './company.state';

const reducer = createReducer(
  initialState,

  on(companyActions.createCompany, state => ({
    ...state,
    loading: true,
    errorMessage: null as any,
  })),
  on(companyActions.createCompanySuccess, (state, { createdCompany }) => ({
    ...state,
    loading: false,
    // companies: [createdCompany, ...state.companies], -- pagination
    errorMessage: null as any,
  })),
  on(companyActions.createCompanyError, (state, { errorMessage }) => ({
    ...state,
    errorMessage,
    loading: false,
  })),

  on(companyActions.getCompany, state => ({
    ...state,
    loading: true,
    errorMessage: null as any,
  })),
  on(companyActions.getCompanySuccess, (state, { company }) => ({
    ...state,
    loading: false,
    loadedCompany: company,
    errorMessage: null as any,
  })),
  on(companyActions.getCompanyError, (state, { errorMessage }) => ({
    ...state,
    errorMessage,
    loading: false,
    loadedCompany: null,
  })),

  on(companyActions.getCompanies, state => ({
    ...state,
    loading: true,
    errorMessage: null as any,
  })),
  on(companyActions.getCompaniesSuccess, (state, { companies }) => ({
    ...state,
    companies: companies.data,
    pagination: companies.pagination,
    loading: false,
    errorMessage: null as any,
  })),
  on(companyActions.getCompaniesError, (state, { errorMessage }) => ({
    ...state,
    errorMessage,
    loading: false,
    pagination: { ...(defaultPagination as Pagination) },
  })),

  on(companyActions.getCompaniesBasicDataList, state => ({
    ...state,
    loading: true,
    errorMessage: null as any,
  })),
  on(companyActions.getCompaniesBasicDataListSuccess, (state, { companies }) => ({
    ...state,
    companies: companies.data,
    pagination: companies.pagination,
    loading: false,
    errorMessage: null as any,
  })),
  on(companyActions.getCompaniesBasicDataListError, (state, { errorMessage }) => ({
    ...state,
    errorMessage,
    loading: false,
    pagination: { ...(defaultPagination as Pagination) },
  })),

  on(companyActions.updateCompany, state => ({
    ...state,
    loading: true,
    errorMessage: null as any,
  })),
  on(companyActions.updateCompanySuccess, (state, { updatedCompany }) => ({
    ...state,
    loading: false,
    errorMessage: null as any,
    companies: state.companies.map(company => (company.id === updatedCompany.id ? updatedCompany : company)),
    loadedCompany:
      state.loadedCompany && state.loadedCompany.id === updatedCompany.id ? updatedCompany : state.loadedCompany,
  })),
  on(companyActions.updateCompanyError, (state, { errorMessage }) => ({
    ...state,
    errorMessage,
    loading: false,
  })),

  on(companyActions.setIsActiveCompany, state => ({
    ...state,
    loading: true,
    errorMessage: null as any,
  })),
  on(companyActions.setIsActiveCompanySuccess, (state, { updatedCompany }) => ({
    ...state,
    loading: false,
    errorMessage: null as any,
    companies: state.companies.map(companyObj =>
      companyObj.id === updatedCompany.id ? { ...updatedCompany } : companyObj
    ),
    loadedCompany:
      state.loadedCompany && state.loadedCompany.id === updatedCompany.id ? updatedCompany : state.loadedCompany,
  })),
  on(companyActions.setIsActiveCompanyError, (state, { errorMessage }) => ({
    ...state,
    errorMessage,
    loading: false,
  })),

  on(companyActions.searchManagersOfCompany, state => ({
    ...state,
    loadingManagersList: true,
    errorMessage: null as any,
  })),
  on(companyActions.searchManagersOfCompanySuccess, (state, { managers }) => ({
    ...state,
    managers: managers.data,
    managersPagination: managers.pagination,
    loadingManagersList: false,
    errorMessage: null as any,
  })),
  on(companyActions.searchManagersOfCompanyError, (state, { errorMessage }) => ({
    ...state,
    loadingManagersList: false,
    errorMessage,
  })),

  on(
    companyActions.createManager,
    companyActions.updateManager,
    companyActions.getManagerDetails,
    companyActions.resendManagerActivation,
    companyActions.softRemoveManager,
    companyActions.restoreManager,
    state => ({
      ...state,
      loadingManagerDetails: true,
      errorMessage: null as any,
    })
  ),
  on(companyActions.resendManagerActivationSuccess, state => ({
    ...state,
    loadingManagerDetails: false,
    errorMessage: null as any,
  })),
  on(companyActions.resendManagerActivationError, (state, { errorMessage }) => ({
    ...state,
    loadingManagerDetails: false,
    errorMessage,
  })),

  on(
    companyActions.createManagerSuccess,
    companyActions.getManagerDetailsSuccess,
    companyActions.updateManagerSuccess,
    companyActions.softRemoveManagerSuccess,
    companyActions.restoreManagerSuccess,
    (state, { manager }) => ({
      ...state,
      loadingManagerDetails: false,
      loadedManagerDetails: manager,
      errorMessage: null as any,
    })
  ),
  on(
    companyActions.createManagerError,
    companyActions.getManagerDetailsError,
    companyActions.addManagedCompanyError,
    companyActions.removeManagedCompanyError,
    companyActions.updateManagerError,
    companyActions.softRemoveManagerError,
    companyActions.restoreManagerError,
    (state, { errorMessage }) => ({
      ...state,
      loadingManagerDetails: false,
      errorMessage,
    })
  ),
  on(companyActions.addManagedCompany, companyActions.removeManagedCompany, state => ({
    ...state,
    loadingManagerDetails: true,
  })),
  on(companyActions.addManagedCompanySuccess, (state, { managedCompany }) => ({
    ...state,
    loadingManagerDetails: false,
    loadedManagerDetails: {
      ...state.loadedManagerDetails,
      managingCompanies: [{ ...managedCompany } as ManagerOfCompany, ...state.loadedManagerDetails.managingCompanies],
    },
  })),
  on(companyActions.removeManagedCompanySuccess, (state, { removedMoc }) => ({
    ...state,
    loadingManagerDetails: false,
    loadedManagerDetails: {
      ...state.loadedManagerDetails,
      managingCompanies: state.loadedManagerDetails.managingCompanies.filter(moc => moc.id !== removedMoc.id),
    },
  })),

  on(companyActions.getCompanyOfSelfRegistered, state => ({
    ...state,
    loadingCompanyOfSelfRegistered: true,
  })),
  on(companyActions.getCompanyOfSelfRegisteredSuccess, (state, { company }) => ({
    ...state,
    loadingCompanyOfSelfRegistered: false,
    companyOfSelfRegistered: company,
  })),
  on(companyActions.getCompanyOfSelfRegisteredError, (state, { errorMessage }) => ({
    ...state,
    loadingCompanyOfSelfRegistered: false,
    errorMessage,
  })),
  on(companyActions.getAllActiveCompanies, state => ({
    ...state,
    loading: true,
  })),
  on(companyActions.getAllActiveCompaniesSuccess, (state, { allActiveCompanies }) => ({
    ...state,
    loading: false,
    allActiveCompanies,
  })),
  on(companyActions.getAllActiveCompaniesError, (state, { errorMessage }) => ({
    ...state,
    loading: false,
    errorMessage,
  })),
  on(companyActions.resetLoadedComapny, state => ({
    ...state,
    loadedCompany: null,
  }))
);

export function companyReducer(state: CompanyState | undefined, action: Action): CompanyState {
  return reducer(state, action);
}
